import { HoneycombSpinner } from './HoneycombSpinner';

interface LoadingSpinnerProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

export function LoadingSpinner({ message = "Ładowanie...", size = "md" }: LoadingSpinnerProps) {
  const sizeValues = {
    sm: 32,
    md: 48,
    lg: 64,
  };

  const spinnerSize = sizeValues[size];

  return (
    <div className="flex flex-col items-center justify-center py-12 animate-fade-in">
      <HoneycombSpinner size={spinnerSize} className="text-honey" />
      {message && <p className="mt-4 text-muted-foreground font-medium">{message}</p>}
    </div>
  );
}

